import { QueryKeys } from "@/lib/queryKeys";
import { useQueryClient } from "@tanstack/react-query";
import React from "react";

export const useInvalidateQuery = () => {
  const queryClient = useQueryClient();

  return (queryKey: QueryKeys) =>
    queryClient.invalidateQueries({ queryKey: [queryKey] });
};
